/**
 * 发起争议处理
 */
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import Api from '@/services';
export default createStore({
    state: {
        abortiveData: {},
        visible: false,
        callback: null,
        stateTip: '',
    },
    effects: {
        confirm(form, { state }) {
            form.validateFields((error, values) => {
                if (!error) {
                    const { abortiveData } = state;
                    const params = {
                        orderId: abortiveData.orderId,
                        failureReason: values.failureReason,
                        orderStatus: abortiveData.orderStatus,
                        recStatus: abortiveData.recStatus,
                    };
                    Api.order.orderFailure(params).then((data) => {
                        if (data) {
                            this.hide();
                            notification.success({ message: '发起流拍成功' });
                        }
                        else {
                            notification.error({ message: '发起流拍失败,请重试' });
                        }
                        state.callback && state.callback(state.id);
                    });
                }
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        show(state, { data, stateTip, callback }) {
            if (data) {
                state.abortiveData = data;
                state.visible = true;
                state.stateTip = stateTip;
                callback && (state.callback = callback);
            }
            else {
                console.warn('流拍提醒组件必需参数id, stateTip,请检查是否传入！');
            }
        },
        hide(state) {
            state.visible = false;
            state.abortiveData = {};
            state.callback = null;
        },
        resetState(state) {
            state.openVal = '';
            state.disputeType = [];
        },
    },
});
